"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const immutable_1 = require("immutable");
const DesignInspirationCase_1 = require("./DesignInspirationCase");
class DesignInspirationCategory {
    constructor({ id, name, iconUrl, designInspirationCases, }) {
        this.toJSON = () => ({
            id: this.id,
            name: this.name,
            iconUrl: this.iconUrl,
            designInspirationCases: this.designInspirationCases && this.designInspirationCases.toJSON(),
        });
        this.id = id;
        this.name = name;
        this.iconUrl = iconUrl;
        this.designInspirationCases = designInspirationCases;
    }
}
DesignInspirationCategory.fromJSON = (json) => {
    const { id, name, iconUrl, designInspirationCases } = Object.assign({}, json);
    if (id !== undefined && typeof id !== 'string')
        throw new Error('.id must be a string');
    if (name !== undefined && typeof name !== 'string')
        throw new Error('.name must be a string');
    if (iconUrl !== undefined && typeof iconUrl !== 'string')
        throw new Error('.iconUrl must be a string');
    if (designInspirationCases !== undefined && !Array.isArray(designInspirationCases))
        throw new Error('.designInpirations must be an array');
    const _designInspirationCases = immutable_1.List(designInspirationCases).map(item => DesignInspirationCase_1.default.fromJSON(item));
    return new DesignInspirationCategory({
        id,
        name,
        iconUrl,
        designInspirationCases: _designInspirationCases,
    });
};
exports.default = DesignInspirationCategory;
